import React, { Component, Fragment } from "react";
import Fade from "react-reveal";

import Landing from "../components/Landing/Landing";
import Mission from "../components/Mission/Mission";
import Products from "../components/Products/Products";
import ProductsTwo from "../components/ProductsTwo/ProductsTwo";
import Footer from "../components/Footer/Footer";
import AgriFreshLanding from "../components/AgriFreshLanding/AgriFreshLanding";
import AgriFreshHow from "../components/AgriFreshHow/AgriFreshHow";
import AgriCarbonHow from "../components/AgriCarbonHow/AgriCarbonHow";
import ResultsOne from "../components/ResultsOne/ResultsOne";
import ResultsTwo from "../components/ResultsTwo/ResultsTwo";
import WhyWeDo from "../components/WhyWeDo/WhyWeDo";
import Founders from "../components/Founders/Founders";
import ContactInfo from "../components/ContactInfo/ContactInfo";
import OurServices from "../components/OurServices/OurServices";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.min.css";

import styles from "./App.module.scss";

export default class App extends Component {
  render() {
    return (
      <div id={styles.ComponentStack}>
        <div className={styles.videoPage}>
          <Fade bottom>
            <Landing></Landing>
          </Fade>
        </div>
        <div className={styles.whiteBackground}>
          <Fade bottom>
            <Mission></Mission>
          </Fade>
        </div>
        <div className={styles.greenBackground}>
          <Fade bottom>
            <Products></Products>
          </Fade>
        </div>
        <div className={styles.greenBackground}>
          <Fade bottom>
            <ProductsTwo></ProductsTwo>
          </Fade>
        </div>
        <div className={styles.videoPage}>
          <Fade bottom>
            <AgriFreshLanding></AgriFreshLanding>
          </Fade>
        </div>
        <div className={styles.whiteBackground}>
          <Fade bottom>
            <AgriFreshHow></AgriFreshHow>
          </Fade>
        </div>
        <div className={styles.whiteBackground}>
          <Fade bottom>
            <ResultsOne></ResultsOne>
          </Fade>
        </div>
        <div className={styles.whiteBackground}>
          <Fade bottom>
            <ResultsTwo></ResultsTwo>
          </Fade>
        </div>
        <div className={styles.greenBackground}>
          <Fade bottom>
            <AgriCarbonHow></AgriCarbonHow>
          </Fade>
        </div>
        <div className={styles.greenBackground}>
          <Fade>
            <WhyWeDo></WhyWeDo>
          </Fade>
        </div>
        <div className={styles.greenBackground}>
          <Fade bottom>
            <Founders></Founders>
          </Fade>
        </div>
        <div className={styles.whiteBackground}>
          <Fade bottom>
            <OurServices></OurServices>
          </Fade>
        </div>
        <div className={styles.whiteBackground}>
          <Fade bottom>
            <ContactInfo></ContactInfo>
          </Fade>
        </div>
        <Footer></Footer>
      </div>
    );
  }
}
